import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "plan",
    serviceName: "auth",
    query: gql`
      query plan(
        $ids: [String]
        $page: Int
        $limit: Int
        $related_to: String
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        plan(
          ids: $ids
          page: $page
          limit: $limit
          related_to: $related_to
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            title
            amount
            is_valid
            related_to
            # quantity
            # order_quantity
            validity_months
            lab_quantity
            unit_quantity
            doctor_quantity
            # agreement_quantity
            code
            details
            purchases {
              id
            }
            media {
              id
              full_url
            }
          }
          total
          last_page
        }
      }
    `,
  },
};

export default schema;
